import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/components/Vectors/Logo.svg';
import _imports_1 from '@/components/Vectors/MenuMobile.svg';

const _withScopeId = n => (_pushScopeId("data-v-e12b3b00"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  id: "top"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "navmobile"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "promodev-va",
  src: "/images/contact-logo.png"
})], -1));

const _hoisted_3 = {
  class: "header_wrapper"
};
const _hoisted_4 = {
  class: "flywrap"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  "svg-inline": "",
  src: _imports_0
}, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Drawer = _resolveComponent("Drawer");

  const _component_Waves = _resolveComponent("Waves");

  return _openBlock(), _createElementBlock("header", _hoisted_1, [_createVNode(_component_Drawer, {
    "is-open": $data.isDrawerOpen,
    speed: 500,
    onClose: $options.closeDrawer
  }, {
    default: _withCtx(() => [_hoisted_2]),
    _: 1
  }, 8, ["is-open", "onClose"]), _createVNode(_component_Waves), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: _normalizeClass({
      fly: $data.flying
    })
  }, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("img", {
    class: "menu-mobile",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.toggleDrawer && $options.toggleDrawer(...args)),
    "svg-inline": "",
    src: _imports_1
  })])], 2)])]);
}